import axios from "axios";
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-materialize";

const UserRow = ({user}) => {
  const [loading, setLoading] = useState(true);
  const [admin, setAdmin] = useState(true);

  useEffect(() => {
    if (user.employee === false) {
      setAdmin("Admin");
    } else {
      setAdmin("Employee");
    }
    setLoading(false)
  }, [user.employee]);

  const onDelete = (event) => {
      setLoading(true)
    axios.delete(`/user/${user.userId}`).then(() => {
      console.log(`deleted ticket ${user.userId}`);
      window.location.reload();
      setLoading(false)
    });
  };

  if (loading) return null;

  return (
    <>
              <div className="row">
                <table className="order-category-wrapper striped left">
                  <tbody>
                    <tr key={user.userId}>
                    <td className="table-col">{admin}</td>
                      <td className="table-col">{user.firstName}</td>
                      <td className="table-col">{user.lastName}</td>
                      <td className="table-col">{user.email}</td>
                      <td className="table-col">{user.phone}</td>
                      <td className="table-col">
                      <Modal
                  trigger={
                    <button className="btn delete-queue">
                      <FontAwesomeIcon
                        className="blk"
                        icon={faTrash}
                        size="s"
                      />
                    </button>
                  }
                >
                  <div className="modal-container">
                    <h4>Confirm Delete</h4>
                    <p>Are you sure you want to delete this from your queue?</p>
                    <button className="btn submit-button" onClick={onDelete}>
                      Yes, Delete{" "}
                    </button>
                  </div>
                </Modal>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
           
    </>
  );
};

export default UserRow;
